export const getCategoryName = (categoryId: number): string => {
    switch (categoryId) {
        case 1: return "COMPANY_NEWS";
        case 2: return "PRESS_RELEASES";
        case 3: return "GUIDES";
        default: return "NEWS";
    }
};